import type { z } from "zod";

import { Response } from "~/shared/api";

const zRes204 = Response.Schema.zNoBody();
const zRes404 = Response.Schema.zUnsuccessful(404);

const zRes = Response.Schema.zAggregated([zRes204, zRes404]);
type Res = z.infer<typeof zRes>;

export { zRes };
export type { Res };
